import { setCookie } from "./cookieUtils";

export function loginResponseHandler(res, navigate) {
  setCookie("accessToken", res.data.access, 7);
  setCookie("refreshToken", res.data.refresh, 7);
  setCookie("userId", res.data.investor.user.id, 7);
  navigate("/");
}
